import { Directive, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[appScrollListener]',
})
export class ScrollListenerDirective implements OnInit, OnDestroy {
  @Output() scrolledToStart = new EventEmitter<void>();
  @Output() scrolledToEnd = new EventEmitter<void>();
  @Output() scrolling = new EventEmitter<void>();

  private resizeObserver: ResizeObserver;
  private resizeTimeout: ReturnType<typeof setTimeout> | null = null;
  private static readonly RESIZE_DEBOUNCE_MS = 300;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.resizeObserver = new ResizeObserver(() => this.scheduleRecheck());
    this.resizeObserver.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
  }

  @HostListener('scroll')
  onScroll(): void {
    this.emitState();
  }

  private scheduleRecheck(): void {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout(() => this.emitState(), ScrollListenerDirective.RESIZE_DEBOUNCE_MS);
  }

  private emitState(): void {
    const element = this.el.nativeElement;
    if (element.scrollLeft === 0) {
      this.scrolledToStart.emit();
    } else if (element.scrollLeft + element.clientWidth >= element.scrollWidth) {
      this.scrolledToEnd.emit();
    } else {
      this.scrolling.emit();
    }
  }
}
